import { CssBaseline, GlobalStyles, ThemeProvider } from '@mui/material';
import React, { ComponentProps } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { ToastContainer } from 'react-toastify';
import { ErrorBoundary } from '@/components/ErrorBoundry';

type AppProviderComponentProps = {
  children?: React.ReactNode;
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});
export function AppProvider({ children }: AppProviderComponentProps) {
  return (
    <ErrorBoundary>
      <CssBaseline>
        <BrowserRouter>
          <QueryClientProvider client={queryClient}>
            <ThemeProvider theme={useCustomTheme()}>
              <ToastContainer
                autoClose={5000}
                hideProgressBar={false}
                pauseOnFocusLoss
                pauseOnHover
                closeOnClick
                position="top-center"
                rtl={false}
                theme="colored"
              />
              {children}
            </ThemeProvider>
          </QueryClientProvider>
        </BrowserRouter>
        <GlobalStyles
          styles={{
            ':root': {
              '--toastify-toast-width': '100%',
            },
          }}
        />
      </CssBaseline>
    </ErrorBoundary>
  );
}

export type AppProviderProps = ComponentProps<typeof AppProvider>;
